/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
//;
import './Modal.scss';

const locale = {
  id: 'RegistrationGuideContent',
  code: 'CN',
  text: {
    'Enter your phone number and password, and then select the school to enter the student registration page': '填写手机号与密码，登陆后请选择相应学校进入学生注册页面',
    'After your student has been registered successfully, student information will be saved and displayed on the student page': '学生注册成功后，信息会存入您学校的学生列表里同时为您建立新学员。',
  }
}
const language = localStorage.getItem('language');

class ModalContent extends React.Component {
  render() {
    return (
      <div className='custom-modal-content'>
        <div className='container-fluid guide-container'>
          <div className='part-one'>
            <div className='step-one'>
              <div className='part-one-steps'>{__('Step One', 'student')}</div>
              <div className='part-one-header'>{__('Enter Self-registration Address on Your Tablet Device', 'student')}</div>
              <div className='part-one-body'>
                {__('Open any browser (Safari, Chrome, Firefox) on your tablet device and enter the following URL ', 'student')}
                <a className='register-link' href='http://register.classtop.com' target='_blank'>register.classtop.com</a>
              </div>
              <div className='part-one-image'><img src={require('data/images/iPadGuide1@2x.png')}/></div>
            </div>
            <div className='step-two'>
              <div className='part-one-steps'>{__('Step Two', 'student')}</div>
              <div className='part-one-header'>{__('Log In to Your School', 'student')}</div>
              <div className='part-one-body'>{__('Enter your phone number and password, and then select the school to enter the student registration page', locale)}</div>
              <div className='part-one-image'></div>
            </div>
            <div className='step-three'>
              <div className='part-one-steps'>{__('Step Three', 'student')}</div>
              <div className='part-one-header'>{__('Enter Student Information', 'student')}</div>
              <div className='part-one-body'>{__('After your student has been registered successfully, student information will be saved and displayed on the student page', locale)}</div>
              <div className='part-one-image'><img src={require(language ==='EN'? 'data/images/iPadGuide2@2x.png': 'data/images/iPadGuide2@2x.png')}/></div>
            </div>
          </div>
          <div className='part-two'>
            <div className='part-two-first-header'>{__('Privacy Setting (only on iPad)', 'student')}</div>
            <div className='part-two-body'>{__('If you do not wish others to change your account information, you could setup privacy setting on your iPad by following the steps below: ', 'student')}</div>
            <div className='part-two-step-one'>
              <div className='part-two-steps'>{__('Step One', 'student')}</div>
              <div className='part-two-header'>{__("On your iPad, press 'Settings' > 'General' > 'Accessibility' > 'Guided Access' to set up Guided Access, you could do the following: ", 'student')}</div>
              <div className='part-two-body'>
                <ul className='guided-ul'>
                  <li>{__('• Turn on/off Guided Access', 'student')}</li>
                  <li>{__('• Setup passcode for Guided Access, such as preventing others from exiting the application', 'student')}</li>
                  <li>{__('• Setup time limits so the application will be disabled once the time expires', 'student')}</li>
                </ul>
              </div>
            </div>
            <div className='step-two'>
              <div className='part-two-steps'>{__('Step Two', 'student')}</div>
              <div className='part-two-header'>{__("To enable Guided Access, please follow the steps below: ", 'student')}</div>
              <div className='part-two-body'>
                <ol className='guided-ol'>
                  <li>{__('1. Open the application', 'student')}</li>
                  <li>{__('2. Press Home Button three times', 'student')}</li>
                  <li>{__("3. Enter the passcode, set up Guided Access, and then press 'Start'", 'student')}</li>
                </ol>
              </div>
            </div>
            <div className='step-three'>
              <div className='part-two-steps'>{__('Step Three', 'student')}</div>
              <div className='part-two-header'>{__("You could use Guided Access to control the application, such as disabling areas of the screen that aren’t relevant to a task, or areas where an accidental gesture might cause a distraction. Please follow the steps below: ", 'student')}</div>
              <div className='part-two-header'>{__("You could use Guided Access to control the application, such as disabling areas of the screen that aren’t relevant to a task, or areas where an accidental gesture might cause a distraction. Please follow the steps below: ", 'student')}</div>
              <div className='part-two-body'>
                <ol className='guided-ol'>
                  <li>{__('1. Circle areas of the screen', 'student')}</li>
                  <li>{__('2. Adjust the areas by dragging the circle', 'student')}</li>
                </ol>
              </div>
              <div className='part-two-header'>
                {__("To disable any screen interaction, please turn off the Touch button", 'student')}
                <br />
                {__("To disable screen lock in the application or any motion, press the 'Hardware Buttons' and turn off 'Motion' button", 'student')}
              </div>
            </div>
            <div className='step-four'>
              <div className='part-two-steps'>{__('Step Four', 'student')}</div>
              <div className='part-two-header'>
                {__("If Touch ID is enabled on your iPad, then it could be used to end Guided Access. Go to 'Settings' > 'General' > 'Accessibility' > 'Guided Access' > 'Passcode Settings'and turn on the Touch ID button. Now you could do the following steps to end Guided Access", 'student')}
              </div>
              <div className='part-two-body'>
                <ol className='guided-ol'>
                  <li>{__('1. Press the Home Button', 'student')}</li>
                  <li>{__('2. Use Touch ID', 'student')}</li>
                </ol>
              </div>
              <div className='part-two-header'>
                {__("If Touch ID is disabled on your iPad, you can end the Guided Access by the following steps", 'student')}
              </div>
              <div className='part-two-body'>
                <ol className='guided-ol'>
                  <li>{__('1. Press the Home Button three times', 'student')}</li>
                  <li>{__("2. Enter the passcode and press 'End'", 'student')}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/iPadGuide/ModalContent.js